import { render } from "./indexthreeblog.vue?vue&type=template&id=189c9982"
import script from "./indexthreeblog.vue?vue&type=script&lang=js"
export * from "./indexthreeblog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__